import styled from "styled-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const DashboardWizardMetricsWrapper = styled.div`
    margin-bottom: 24px;
`;
export const CampaignsPickerWrapper = styled.div`
    margin-bottom: 24px;
    width: 50%;
`;
export const DeviceLocationsPickersWrapper = styled(FlexRow)`
    gap: 24px;
    margin-bottom: 24px;
`;
export const LocationsPickerWrapper = styled(FlexColumn)`
    width: 100%;
`;
export const CampaignsDurationFilterWrapper = styled.div`
    border: 1px solid ${colorsPalettes.midnight[50]};
`;
export const CompetitorsDropdownContainer = styled.div`
    margin-bottom: 24px;
    width: 50%;
`;

export const TagsDropdownContainer = styled.div`
    margin-bottom: 56px;
    width: 50%;
`;

export const SmallTitle = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[250])};
    margin-bottom: 8px;
`;
export const SectionTitle = styled.div`
    ${setFontVariant("subTitle3", colorsPalettes.carbon[500])};
    margin-bottom: 16px;
`;

export const OptionalTagWrapper = styled.div`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[100])};
    margin-left: 8px;
    line-height: 22px;
`;
